const isPreLaunchMode = process.env.REACT_APP_PRE_LAUNCH_MODE === 'true';
export default isPreLaunchMode;